"use client";

import { useBaseConfig, useSupportedGameCurrencies } from "@/hooks/api/usePublic";
import { useBoundStore } from "@/store";
import type { Currency } from "@/types/currency";
import { useEffect, useMemo } from "react";
import { findFixedCountryFiatCurrency, resolveFixedRegistrationCountryCode } from "@/utils/registrationCountry";

// 同步登录用户的结算币种/展示币种，并在可用币种变化时做兜底回退。
export function CurrencyStateSync() {
  const { data: supportedCurrencies } = useSupportedGameCurrencies();
  const { data: baseConfig } = useBaseConfig();

  const user = useBoundStore((state) => state.user);

  const displayCurrency = useBoundStore((s) => s.displayCurrency);

  const setDisplayCurrency = useBoundStore((s) => s.setDisplayCurrency);

  const setSettlementCurrency = useBoundStore((s) => s.setSettlementCurrency);

  const currencies = useMemo(() => (supportedCurrencies?.data ?? []) as Currency[], [supportedCurrencies?.data]);
  const fixedCountryFiatCurrency = useMemo(() => {
    const fixedCountryCode = resolveFixedRegistrationCountryCode(baseConfig);
    return findFixedCountryFiatCurrency(currencies, fixedCountryCode);
  }, [baseConfig, currencies]);

  useEffect(() => {
    if (user?.currency) {
      setSettlementCurrency(user.currency);
    }
  }, [setSettlementCurrency, user?.currency]);

  useEffect(() => {
    if (user?.currency_fiat) {
      setDisplayCurrency(user.currency_fiat);
    }
  }, [setDisplayCurrency, user?.currency_fiat]);

  useEffect(() => {
    if (user?.currency_fiat) return;
    if (!currencies?.length) return;

    if (fixedCountryFiatCurrency?.currency && displayCurrency !== fixedCountryFiatCurrency.currency) {
      setDisplayCurrency(fixedCountryFiatCurrency.currency);
    }
  }, [currencies?.length, displayCurrency, fixedCountryFiatCurrency, setDisplayCurrency, user?.currency_fiat]);

  useEffect(() => {
    if (!currencies?.length) return;

    if (!currencies.some((c) => c.currency === displayCurrency)) {
      setDisplayCurrency(fixedCountryFiatCurrency?.currency ?? "USD");
    }
  }, [currencies, displayCurrency, fixedCountryFiatCurrency, setDisplayCurrency]);

  return null;
}
